/**
 * 版本不匹配弹窗工具
 * 当后端返回 4001 错误码时，显示提示用户刷新页面的弹窗
 */

let isDialogVisible = false

/**
 * 显示版本不匹配弹窗
 * 提供「稍后刷新」和「立即刷新」两个选项
 * 用户可以选择稍后刷新继续查看当前内容，但下次 API 请求仍会弹窗
 */
export function showVersionMismatchDialog(): void {
  // 如果弹窗已经在显示，不重复创建
  if (isDialogVisible) return
  isDialogVisible = true

  const overlay = document.createElement('div')
  overlay.id = 'version-mismatch-dialog'
  overlay.innerHTML = `
    <style>
      #version-mismatch-dialog {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.45);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: vmd-fade-in 0.2s ease;
      }
      @keyframes vmd-fade-in {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      .vmd-card {
        background: white;
        padding: 32px 40px;
        border-radius: 12px;
        text-align: center;
        max-width: 360px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
        animation: vmd-scale-in 0.2s ease;
      }
      @keyframes vmd-scale-in {
        from { transform: scale(0.9); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
      .vmd-icon { font-size: 48px; margin-bottom: 16px; }
      .vmd-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
      }
      .vmd-desc {
        font-size: 14px;
        color: #666;
        margin-bottom: 24px;
        line-height: 1.6;
      }
      .vmd-buttons {
        display: flex;
        gap: 12px;
        justify-content: center;
      }
      .vmd-btn {
        padding: 8px 20px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s;
        border: none;
      }
      .vmd-btn-secondary {
        background: #f5f5f5;
        color: #666;
      }
      .vmd-btn-secondary:hover { background: #e8e8e8; }
      .vmd-btn-primary {
        background: #18a058;
        color: white;
      }
      .vmd-btn-primary:hover { background: #16914e; }
    </style>
    <div class="vmd-card">
      <div class="vmd-icon">🔄</div>
      <div class="vmd-title">发现新版本</div>
      <div class="vmd-desc">应用已更新到最新版本，<br>建议刷新页面以获得最佳体验</div>
      <div class="vmd-buttons">
        <button class="vmd-btn vmd-btn-secondary" id="vmd-later">稍后刷新</button>
        <button class="vmd-btn vmd-btn-primary" id="vmd-now">立即刷新</button>
      </div>
    </div>
  `

  document.body.appendChild(overlay)

  // 绑定事件
  document.getElementById('vmd-now')?.addEventListener('click', () => {
    location.reload()
  })

  document.getElementById('vmd-later')?.addEventListener('click', closeDialog)

  // 点击遮罩关闭
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeDialog()
  })

  // ESC 关闭
  const escHandler = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      closeDialog()
      document.removeEventListener('keydown', escHandler)
    }
  }
  document.addEventListener('keydown', escHandler)
}

/**
 * 关闭弹窗
 * 注意：不会阻止下次 API 请求时再次弹窗
 */
function closeDialog(): void {
  isDialogVisible = false
  const dialog = document.getElementById('version-mismatch-dialog')
  if (dialog) {
    dialog.remove()
  }
}
